import { lighten } from '@mui/system'

import Colors from '#/styles/Colors'

export const rowStyle = row => {
  if (
    !row.deleted_at &&
    (['reproduction.birth.user', 'reproduction.induced_lactation.any'].includes(row.virtual_type) ||
      (row.virtual_type === 'reproduction.birth.algorithm' && row.confirmed_as))
  ) {
    return {
      '& div ': {
        fontWeight: '500',
      },
      'borderTop': `2px solid ${Colors.warning}`,
      'color': Colors.feedback.success.color,
    }
  }

  if (['reproduction.abortion.any', 'discard.death.any'].includes(row.virtual_type)) {
    return {
      '& div ': {
        fontWeight: '500',
      },
      'backgroundColor': lighten(Colors.feedback.error.backgroundColor, 0.5),
      'color': Colors.feedback.error.color,
    }
  }

  if (['reproduction.heat.algorithm'].includes(row.virtual_type) && row.confirmed_as === false) {
    return {
      '&:not(:has(.MuiChip-root))': {
        color: Colors.feedback.neutral.color,
        textDecoration: 'line-through',
      },
    }
  }

  return {}
}

/**
 * Verifica se uma linha de dados pode ser editada ou excluída com base no seu tipo virtual e status
 *
 * @param {Object} row - O objeto representando a linha de dados
 * @param {string} actionType - O tipo de ação ('update' para edição ou qualquer outro valor para outras ações)
 * @returns {boolean} - Retorna true se a ação for permitida, false caso contrário
 */
export const checkEditAndDelete = (row, actionType) => {
  // Bloqueia operações para tipos virtuais específicos de entrada e saida
  /**
   * Como os forms estão quebrados, estou removendo as ações
   */
  const isProtectedType = ['discard.departure.any', 'arrival.arrival.any'].includes(
    row.virtual_type,
  )

  if (isProtectedType) {
    return false
  }

  // Bloqueia operações para tipos virtuais relacionados a reprodução (cobertura, nascimento, algoritmos)
  const isReproductionProtected =
    row.virtual_type &&
    row.virtual_type.match(
      /(reproduction\.(heat|birth)\.algorithm|reproduction\.implant_insertion.*|reproduction\.implant_removal.*)/,
    )

  if (isReproductionProtected) {
    return false
  }

  // Bloqueia especificamente operações de edição para implantes reprodutivos
  const isImplantEdit =
    actionType === 'update' && row.virtual_type && row.virtual_type.match(/reproduction\.implant_*/)

  if (isImplantEdit) {
    return false
  }

  // Permite a ação apenas se o registro não estiver marcado como deletado
  return row.deleted_at === null
}
